import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LeaseAgreementDocumentService } from '../../service/data/lease-agreement-document.service';
import { LeaseAgreementDocument } from '../../model/lease-agreement-document';
import { DocumentVisibilityKind, DocumentVisibilityKindToString } from '../../../common/model/const/enum';

@Component({
    selector: 'app-change-document-visibility',
    templateUrl: './change-document-visibility.component.html',
    styleUrls: ['./change-document-visibility.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeDocumentVisibilityComponent implements OnInit, OnDestroy {
  constructor(
    private _dataService: LeaseAgreementDocumentService,
    private _modalService: ActionWindowService,
    cf: FormControlExFactory,
    fb: FormBuilder
  ) {
    this.form = fb.group({
      visibility: cf.createMandatory('COMMON.DISPLAYED_FOR', DocumentVisibilityKind.LandlordPages),
      id: cf.createHidden(''),
    });
  }

  linkedLeaseAgreementDocument: LeaseAgreementDocument;
  private sub: Subscription;

  private _dataContext: {
    linkedLeaseAgreementDocuments?: LeaseAgreementDocument[];
  };

  get dataContext(): {
    linkedLeaseAgreementDocuments?: LeaseAgreementDocument[];
  } {
    return this._dataContext;
  }
  set dataContext(value: { linkedLeaseAgreementDocuments?: LeaseAgreementDocument[] }) {
    this._dataContext = value;
    if (value.linkedLeaseAgreementDocuments instanceof Array) {
      if (this.dataContext.linkedLeaseAgreementDocuments && this.dataContext.linkedLeaseAgreementDocuments.length == 1) {
        this.linkedLeaseAgreementDocument = this.dataContext.linkedLeaseAgreementDocuments[0];
        this.form.controls['id'].setValue(this.linkedLeaseAgreementDocument.id);
        this.form.controls['visibility'].setValue(DocumentVisibilityKind.LandlordPages);
      }
    }
  }
  readonly form: FormGroup;
  visibilityLevels = [
    { name: DocumentVisibilityKindToString(DocumentVisibilityKind.LandlordPages), value: DocumentVisibilityKind.LandlordPages },
    {
      name: DocumentVisibilityKindToString(DocumentVisibilityKind.LandlordPagesAndTenantPages),
      value: DocumentVisibilityKind.LandlordPagesAndTenantPages,
    },
  ];

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  cancel() {
    this._modalService.close();
  }

  ngOnInit() {}

  onSubmit() {
    if (this.form.invalid) return;

    this.form.disable();

    if (this.sub) {
      this.sub.unsubscribe();
    }

    if (this.linkedLeaseAgreementDocument) {
      this.sub = this._dataService.changeVisibilityLevel(this.form.value).subscribe(
        res => {
          this._modalService.complete(res);
          this._modalService.close();
        },
        error => this.form.enable()
      );
      return;
    }
  }
}
